import { render } from "./TerminationModal.vue?vue&type=template&id=1c5bcd22&scoped=true"
import script from "./TerminationModal.vue?vue&type=script&lang=js"
export * from "./TerminationModal.vue?vue&type=script&lang=js"

import "./TerminationModal.vue?vue&type=style&index=0&id=1c5bcd22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5bcd22"]])

export default __exports__